import Link from 'next/link';

// Social icons — display only, not linked to any profile yet.
const socials = [
  {
    label: 'LinkedIn',
    svg: (
      <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14zM7.12 20.45H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.22.79 24 1.77 24h20.45c.98 0 1.78-.78 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
      </svg>
    ),
  },
  { label: 'Instagram', icon: 'photo_camera' },
  { label: 'YouTube', icon: 'smart_display' },
  {
    label: 'Facebook',
    svg: (
      <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07c0 6.02 4.39 11.01 10.12 11.93v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.95.93-1.95 1.89v2.25h3.32l-.53 3.49h-2.79v8.44C19.61 23.08 24 18.09 24 12.07z" />
      </svg>
    ),
  },
];

const columns = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '/features' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Gallery', href: '/gallery' },
      // { label: 'For Studios', href: '/studios' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us', href: '/about' },
      { label: 'Contact Us', href: '/contact' },
      { label: 'Help Center', href: '/help' },
    ],
  },
  {
    title: 'Support',
    span: 'lg:col-span-3',
    links: [
      { label: 'Refund Policy', href: '/refund' },
      { label: 'Terms & Conditions', href: '/terms' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Cookie Policy', href: '/cookies' },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="bg-ink text-white/65">
      <div className="max-w-container mx-auto px-8 md:px-10 pt-20 pb-14">
        <div className="grid grid-cols-2 lg:grid-cols-12 gap-x-8 gap-y-14">
          {/* Brand block */}
          <div className="col-span-2 lg:col-span-4 lg:pr-12 flex flex-col">
            <Link
              href="/"
              className="serif text-[34px] leading-none text-white tracking-tight inline-flex items-baseline gap-2 no-underline"
            >
              <span className="serif-it text-gold-soft text-[40px] leading-none">∞</span>
              <span>
                Time<span className="text-gold-soft">Lens</span>
              </span>
            </Link>
            <p className="text-[15px] leading-relaxed text-white/55 mt-6 max-w-[300px]">
              India&apos;s first unlimited cloud gallery, built for timeless memories.
            </p>

            {/* social — icons only, not linked */}
            <div className="flex items-center gap-3 mt-9">
              {socials.map((s) => (
                <a
                  key={s.label}
                  aria-label={s.label}
                  className="w-[42px] h-[42px] rounded-full border border-white/20 flex items-center justify-center text-white/70 cursor-pointer transition-all duration-300 hover:bg-gold-soft hover:border-gold-soft hover:text-[#14120c] hover:-translate-y-0.5"
                >
                  {s.svg ?? <span className="material-symbols-outlined text-[20px]">{s.icon}</span>}
                </a>
              ))}
            </div>
          </div>

          {/* Spacer column on large screens */}
          <div className="hidden lg:block lg:col-span-1" />

          {/* Link columns */}
          {columns.map((col) => (
            <nav key={col.title} className={col.span ?? 'lg:col-span-2'}>
              <div className="label text-white/35 mb-6">{col.title}</div>
              <ul className="space-y-4 text-[15px] list-none p-0 m-0">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      href={link.href}
                      className="link-u hover:text-white transition-colors no-underline"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
      </div>

      {/* bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-container mx-auto px-8 md:px-10 py-7 flex flex-col md:flex-row items-center justify-between gap-3">
          <span className="mono text-[11px] tracking-[.18em] uppercase text-white/40">
            © 2026 TimeLens · All rights reserved
          </span>
          <span className="mono text-[11px] tracking-[.18em] uppercase text-white/40">
            A lifetime of memories · all in one place
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
